import { CustomWaypointContract, VisitContract } from '../store/loops/types';

export const instanceOfVisit = (object: any): object is VisitContract => {
  return (
    object !== undefined &&
    'type' in object &&
    'index' in object &&
    'account' in object
  );
};

export const instanceOfWaypoint = (
  object: any,
): object is CustomWaypointContract => {
  return (
    object !== undefined &&
    'latitude' in object &&
    'longitude' in object &&
    'index' in object &&
    'name' in object
  );
};
